import Vue from 'vue'

export default {
	state: {
		allChannels: [],//all channels
		channels: [],//company channels 
		independentChains: [],
		channelParams: [
		{
			name:'Online',
			type: 0,
			constructionInvestments: 10000,
			operationalCosts: 40000,
			marketCoverage: 200000
		},
		{
			name:'Brick&mortar',
			type: 1,
			constructionInvestments: 5000,
			operationalCosts: 60000,
			marketCoverage: 30000
		},
		{
			name:'Franchise',
			type: 2,
			constructionInvestments: 5000,
			operationalCosts: 60000,
			marketCoverage: 30000
		},
		{name: 'independent-online'}, 
		{name: 'independent-brick&mortar'}
		],
	},
	mutations: {
		loadChannels (state, payload) {
			state.channels = payload
		},
		loadAllChannels (state, payload) {
			state.allChannels = payload
		},
		loadIndependentChains (state, payload) {
			state.independentChains = payload
		},
		addChannel (state, payload) { 
			const index = state.channels.length
			Vue.set(state.channels, index, payload)  
		},
		addChain (state, payload) { 
			const index = state.independentChains.length
			Vue.set(state.independentChains, index, payload) 
		},
		changeChannel (state, payload) {
			const item = state.channels.find(ch => ch.id === payload.id)
			Vue.set(state.channels, state.channels.indexOf(item), payload)  
		},
		//change independent chain
		changeChain (state, payload) {
			const item = state.independentChains.find(ch => ch.id === payload.id)
			Vue.set(state.independentChains, state.independentChains.indexOf(item), payload)  
		},
		deleteChannel (state, payload) {
			state.channels = state.channels.filter(chanel => chanel.id !== payload) 
		},
		//delete cain
		deleteChain (state, payload) {
			state.independentChains = state.independentChains.filter(chanel => chanel.id !== payload) 
		}
	},
	actions: {
		async fetchAllChannels ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []

			let gameId = 'game' + payload.gameId
			let round = 'round' + payload.round

			try {
				const channels = await Vue.$db.collection(gameId).doc(round).collection('channels')
				.get()

				if (channels) {
					channels.forEach(doc => {
						const channel = doc.data()

						channel.id = doc.id
						resArr.push(channel)
					})
					
					commit('loadAllChannels', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchChannels ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []

			let gameId = 'game'
			let round = 'round'
			let company = ''

			if (payload) {
				gameId+= payload.gameId
				round+= payload.round
				company = payload.company
			}
			else {
				gameId+= getters.gameId
				round+= getters.currentRound
				company = getters.company
			}
			try {
				const channels = await Vue.$db.collection(gameId).doc(round).collection('channels')
				.where("company", "==", company)
				.get()

				if (channels) {
					channels.forEach(doc => {
						const channel = doc.data()

						channel.id = doc.id
						resArr.push(channel)
					})
					
					commit('loadChannels', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchIndependentChains ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			const resArr = []

			let gameId = 'game' 
			let round = 'round'
			
			if (payload){
				gameId+= payload.gameId
				round+= payload.round
			}
			else {
				gameId+= getters.gameId
				round+= getters.currentRound
			} 

			try {
				const channels = await Vue.$db.collection(gameId).doc(round).collection('independentChains')
				.get()

				if (channels) {
					channels.forEach(doc => {
						const channel = doc.data()

						channel.id = doc.id
						resArr.push(channel)
					})
					commit('loadIndependentChains', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//for company
		async addChannel ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			let id = payload.channel.id

			if (!id) {
				id = `${payload.channel.company}-${payload.channel.name}`	
			}
			else {
				delete payload.channel.id
			}
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('channels')
				.doc(id).set(payload.channel)
				
				payload.channel.id = id
				
				commit('setLoading', false)
				commit('addChannel', payload.channel)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//add independent chain
		async addChain ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			let id = payload.chain.id

			if (!id) {
				id = `chain ${payload.chain.name}`
			}
			else {
				delete payload.chain.id
			}
			
			try {
				const chanRef = await Vue.$db.collection(gameId).doc(round).collection('independentChains')
				.doc(id)
				.set(payload.chain)

				payload.chain.id = id
				
				commit('setLoading', false)
				commit('addChain',payload.chain)
				
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async changeChannel ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.channel.id

			delete payload.channel.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('channels')
				.doc(id)
				.set(payload.channel)

				payload.channel.id = id

				commit('setLoading', false)
				commit('changeChannel', payload.channel)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//change independent chain
		async changeChain ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.chain.id

			delete payload.chain.id
			
			try {
				const chanRef = await Vue.$db.collection(gameId).doc(round).collection('independentChains')
				.doc(id)

				await chanRef.set(payload.chain)

				payload.chain.id = id

				commit('setLoading', false)
				commit('changeChain', payload.chain)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async deleteChannel ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.channel
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('channels').doc(id).delete()

				commit('setLoading', false)
				commit('deleteChannel', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		//delete independent chain
		async deleteChain ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)

			const gameId = 'game' + payload.gameId
			const round = 'round' + payload.round
			const id = payload.id
			
			try {
				await Vue.$db.collection(gameId).doc(round).collection('inIndependentChains').doc(id).delete()

				commit('setLoading', false)
				commit('deleteChain', id)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		}
	},
	getters: {
		allChannels (state) {
			return state.allChannels
		},
		channels (state) {
			return state.channels
		},
		onlineSelfStores (state) {
			return state.channels.filter(channel => channel.type === 0)
		},
		outlets (state) {
			return state.channels.filter(channel => channel.type === 1)
		},
		franchises (state) {
			return state.channels.filter(channel => channel.type === 2)
		},
		inIndependentChains (state) {//присутствие в marketplaces || chains
			return state.channels.filter(channel => channel.type > 2)
		},
		channelParams (state) {
			return state.channelParams
		},
		independentChains (state) {
			return state.independentChains
		},
		marketplaces (state) {
			return state.independentChains.filter(channel => channel.type === 3)
		},
		chains (state) {
			return state.independentChains.filter(channel => channel.type === 4)
		}
	}
}